import AuthRepository from "./authRepository";
import UsersRepository from "./usersRepository";
import CompaniesRepository from "./companiesRepository";
import FilesRepository from "./filesRepository";
import ApplicationsRepository from "./applicationsRepository";
import PersonasRepository from "./personasRepository";
import PerimetresRepository from "./perimetresRepository";
import SocietesRepository from "./societesRepository";
import FilialesRepository from "./filialeRepository";
import GroupesRepository from "./groupeRepository";
import ExportsRepository from "./exportsRepository";
import NotificationsRepository from "./notificationsRepository";

export const AUTH_REPOSITORY = "auth";
export const USERS_REPOSITORY = "users";
export const COMPANIES_REPOSITORY = "companies";
export const FILES_REPOSITORY = "files";
export const APPLICATIONS_REPOSITORY = "applications";
export const PERSONAS_REPOSITORY = "personas";
export const PERIMETRES_REPOSITORY = "perimetres";
export const SOCIETES_REPOSITORY = "societes";
export const FILIALES_REPOSITORY = "filiales";
export const GROUPES_REPOSITORY = "groupes";
export const EXPORTS_REPOSITORY = "exports";
export const NOTIFICATIONS_REPOSITORY = "notifications";

const repositories = {
  [AUTH_REPOSITORY]: AuthRepository,
  [USERS_REPOSITORY]: UsersRepository,
  [COMPANIES_REPOSITORY]: CompaniesRepository,
  [FILES_REPOSITORY]: FilesRepository,
  [APPLICATIONS_REPOSITORY]: ApplicationsRepository,
  [PERSONAS_REPOSITORY]: PersonasRepository,
  [PERIMETRES_REPOSITORY]: PerimetresRepository,
  [SOCIETES_REPOSITORY]: SocietesRepository,
  [FILIALES_REPOSITORY]: FilialesRepository,
  [GROUPES_REPOSITORY]: GroupesRepository,
  [EXPORTS_REPOSITORY]: ExportsRepository,
  [NOTIFICATIONS_REPOSITORY]: NotificationsRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
